import styled from 'styled-components'

export const ContainerAnalises = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;

  /* A Box ocupa a altura restante; quem rola é a ContainerLista dentro dela,
     mantendo header e rodapé de totais sempre visíveis. */
  > div:first-child {
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }

  h3 {
    font-weight: 600;
    font-size: 12px;
    margin: 0;
    padding: 0;
    color: #7b7b7b;
  }

  .footer__analises {
    width: 100%;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 2px solid #d9d9d9;
    margin-top: 10px;
    padding: 5px;
    gap: 3px;
    border-radius: 10px;

    .detalhes {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .detalhes:is([data-active='true']) {
      padding: 10px;
      display: flex;
      flex-direction: column;
      background-color: #f6ffed;
      color: #5da57d;
      border-radius: 5px;

      span {
        font-size: 13px;
        font-weight: 500 !important;
      }
    }
  }

  div.overlay_loading_lab {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
